import React, { useEffect, useState } from "react";
import { Button, Popconfirm, Table, Tag } from "antd";
import { del, get } from "../../api/axios";
import { Pagination,
  /// message 
  } from "antd";
// import { Link } from "react-router-dom";
import SearchBar from "../../utils/SearchBar";

const Invoices = () => {
  // render: (role) => (role == null ? "" : role.name),

  // const splitDateRange = (date) => {
  //   if (!date) return { from: "", to: "" };

  //   const [from, to] = date.split(" - ");
  //   return { from, to };
  // };

  const columns = [
    // {
    //   title: " رقم الحجز",
    //   dataIndex: "id",
    //   width: "200px",
    // },
    // {
    //   title: " حالة الحجز",
    //   dataIndex: "status",
    //   width: "200px",
    // },

    //1
    //بيانات الحجز
    {
      title: (
        <>
          بيانات الحجز
          <br />
          رقم الحجز
          <br />
          حالة الحجز
          <br />
          مصدر الحجز
          <br />
          جهة الحجز
          <br />
          تاريخ انشاء الحجز
          <br />
          رقم الوحدة
          <br />
          سياسة الالغاء
        </>
      ),
      width: "250px",

      render: ({
        id,
        status,
        date_of_creation,
        time_of_creation,
        reservation_source,
        cancellation_policy,
      }) => (
        <span>
          <strong>{id}</strong>
          <br />
          <Tag color={status === "confirmed" ? "green" : "orange"}>
            {status}
          </Tag>
          <br />
          {reservation_source === "user" ? "مكان" : "مضيف"}
          <br />
          جهة الحجز
          <br />
          {date_of_creation}
          <br />
          رقم الوحدة
          <br />
          {cancellation_policy || "-"}
        </span>
      ),
    },

    //2
    //بيانات الاقامة
    {
      title: (
        <>
          بيانات الإقامة
          <br />
          اسم الوحدة
          <br />
          المدينة
          <br />
          الحي
          <br />
          تاريخ الوصول
          <br />
          تاريخ المغادرة
          <br />
          وقت الوصول
          <br />
          وقت المغادرة
          <br />
          مدة الإقامة
        </>
      ),
      dataIndex: "",
      width: "200px",

      render: (
        { date, arriving_time, leaving_time, type },
        { daysNumbers },
        { property },
      ) => {
        const splitDateRange = (date) => {
          if (!date || typeof date !== "string") {
            return { from: "-", to: null };
          }

          const parts = date.split(" - ");

          return {
            from: parts[0],
            to: parts[1] || null,
          };
        };

        const { from, to } = splitDateRange(date);

        return (
          <div>
            اسم الوحدة
            <br />
            {property?.city || "-"}
            <br />
            {property?.district || "-"}
            الحي
            <br />
            {from}
            {to && <div>{to}</div>}
            {arriving_time || "-"}
            <br />
            {leaving_time || "-"}
            <br />
            {daysNumbers || "-"}
          </div>
        );
      },
    },

    //3
    //بيانات الضيف والمضيف
    {
      title: (
        <>
          بيانات الضيف والمضيف
          <br />
          أسم الضيف
          <br />
          البريد الالكتروني
          <br />
          الجوال
          <br />
          رقم الضيف
          <br />
          أسم المضيف
          <br />
          البريد الالكتروني
          <br />
          الجوال
          <br />
          رقم المضيف
          <br />
        </>
      ),
      width: "200px",
      dataIndex: "user",
      render: ({ name, phone, email }) => (
        <span>
          {name}
          <br />
          {email}
          <br />
          {phone}
        </span>
      ),
    },

    //4
    //بيانات السعر
    {
      title: (
        <>
          بيانات السعر
          <br />
          طريقة السداد
          <br />
          المدة * سعر الليلة
          <br />
          إجمالي السعر
          <br />
          العرض
          <br />
          كود خصم
          <br />
          مبلغ الحجز
          <br />
          رسوم الخدمة
          <br />
          المجموع
        </>
      ),
      width: "200px",

      render: ({ prices, daysNumbers, total_price, payment_method }) => (
        <>
          {payment_method || "-"} <br />
          {daysNumbers} * {prices.avg_price} <br />
          {prices.totalPrice} <br />
          {prices.offers_amount} <br />
          {prices.coupon_amount} <br />
          {prices.subTotal} <br />
          {prices.total_service} <br />
          {total_price} <br />
        </>
      ),
    },

    //5
    //الرسوم
    {
      title: (
        <>
          الرسوم
          <br />
          المدفوع من الضيف
          <br />
          رسوم الخدمة قبل الضريبة <br />
          ضريبة القيمة المضافة(الرسوم)
          <br />
          (الرسوم شامل الضريبة)
          <br />
          مبلغ الحجز
        </>
      ),
      width: "200px",

      dataIndex: "prices",

      render: ({
        totalPrice,
        service_amount,
        service_tax,
        total_service,
        total_price_without_service,
      }) => (
        <span>
          {totalPrice}
          <br />
          {service_amount}
          <br />
          {service_tax}
          <br />
          {total_service}
          <br />
          {total_price_without_service}
        </span>
      ),
    },

    //6
    // العمولة
    {
      title: (
        <>
          العمولة
          <br />
          مبلغ الحجز <br />
          العمولة <br />
          ضريبة القيمة المضافة
          <br />
          العمولة شامل الضريبة
          <br />
          صافي مبيعات المضيف
        </>
      ),
      width: "200px",

      dataIndex: "prices",
      render: ({
        total_price_without_service,
        commission_amount,
        commission_tax_amount,
        total_commission,
        total_price_without_service_commission,
      }) => (
        <span>
          {total_price_without_service}
          <br />
          {commission_amount}
          <br />
          {commission_tax_amount}
          <br />
          {total_commission}
          <br />
          {total_price_without_service_commission}
        </span>
      ),
    },

    //7
    //بيانات الفاتورة
    {
      title: (
        <>
          بيانات الفاتورة
          <br />
          تاريخ فاتورة الضيف
          <br />
          رقم فاتورة الضيف
          <br />
          عرض فاتورة الضيف
          <br />
          تاريخ فاتورة المضيف
          <br />
          رقم فاتورة المضيف
          <br />
          عرض فاتورة المضيف
        </>
      ),
      width: "200px",

      render: ({ user, owner }) => (
        <span>
          {user?.invoice?.created_at}
          <br />
          {user?.invoice?.number}
          <br />
          {user?.invoice?.invoice_path ? (
            <a
              className="text-decoration-none"
              target="_blank"
              rel="noreferrer"
              href={user?.invoice?.invoice_path}
            >
              عرض فاتورة الضيف
            </a>
          ) : (
            "-"
          )}
          <br />
          {owner?.invoice?.created_at}
          <br />
          {owner?.invoice?.number}
          <br />
          {owner?.invoice?.invoice_path ? (
            <a
              className="text-decoration-none"
              target="_blank"
              rel="noreferrer"
              href={owner?.invoice?.invoice_path}
            >
              عرض فاتورة الضيف
            </a>
          ) : (
            "-"
          )}
        </span>
      ),
    },

    // {
    //   title: (
    //     <>
    //       بيانات الوحدة
    //       <br />
    //       الوحدة
    //       <br />
    //       المدينة
    //       <br />
    //       الحي
    //       <br />
    //       كود الوحدة
    //       <br />
    //     </>
    //   ),
    //   width: "150px",

    //   dataIndex: "",
    //   render: ({ property, cancellation_policy }) => (
    //     <span>
    //       {property?.name}
    //       <br />
    //       {property?.city}
    //       <br />
    //       {property?.district}
    //       <br />
    //       {property?.code}
    //       <br />
    //       {cancellation_policy || "-"}
    //     </span>
    //   ),
    // },

    // {
    //   title: (
    //     <>
    //       بيانات المضيف
    //       <br />
    //       الاسم
    //       <br />
    //       الجوال
    //       <br />
    //       البريد الالكتروني
    //       <br />
    //       رقم المضيف
    //       <br />
    //     </>
    //   ),
    //   dataIndex: "owner",
    //   width: "200px",

    //   render: (owner) => (
    //     <span>
    //       {owner?.name || "غير متوفر"}
    //       <br />
    //       {owner?.phone || "غير متوفر"}
    //       <br />
    //       {owner?.email || "غير متوفر"}
    //     </span>
    //   ),
    // },
  ];

  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedValue, setDebouncedValue] = useState(searchQuery);

  const [total, setTotal] = useState(1);

  useEffect(() => {
    get(`invoices?search=${searchQuery}`).then((res) => {
      setdata(res?.data.data);
      setTotal(res?.data.meta.last_page);
      setLoading(false);
    });
  }, [debouncedValue]);
  const handlePagination = (pageNumber) => {
    setLoading(true);

    get(`invoices?page=${pageNumber}`).then((res) => {
      setdata(res.data.data);
      setLoading(false);
    });
  };

  return (
    <div>
      <div className="row">
        <SearchBar
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          debouncedValue={debouncedValue}
          setDebouncedValue={setDebouncedValue}
        />
        <div className="col-12 grid-margin stretch-card">
          <div className="w-100">
            <Table
              locale={{ emptyText: "لا يوجد عناصر" }}
              loading={loading}
              pagination={false}
              bordered
              scroll={{
                //     x: 1350,
                y: "65vh",
              }}
              columns={columns}
              dataSource={data}
              size="middle"
            />
            <Pagination
              defaultCurrent={1}
              className="mt-4 d-flex align-items-center justify-content-center"
              position="bottomCenter"
              total={total * 10}
              onChange={handlePagination}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Invoices;
